<template>
    <b-modal
            v-model="show"
            title="Добавление сотрудника"
            @hide="close(false)"
    >
        <div>
            <b-container fluid>
                <b-row no-gutters class="mb-2">
                <b-col>
                    <label class="custom-input-label">ФИО</label>
                    <b-input
                            placeholder="Иванов Иван Иванович"
                            v-model="webUserModel.userName"
                            required
                    />
                </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Телефон</label>

                            <b-input
                                    placeholder="9876543210"
                                    v-model="webUserModel.phoneNumber"
                                    :formatter="formatPhone"
                                    class="phone"
                                    :state="errors.findIndex(x=>x.key='phoneNumber')!=-1?webUserModel.phoneNumber!=null&&webUserModel.phoneNumber!=''?true:false:null"
                            /><label class="phone" style="bottom:5px" data-fon="+7">&nbsp;</label>

                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Организация</label>
                        <div class="disabled-filled-option">{{orgName}}</div>
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col>
                        <label class="custom-input-label">Уровень доступа</label>
                        <b-select
                                :options="accessLevels"
                                value-field="id"
                                text-field="name"
                                rows="6"
                                v-model="webUserModel.webUserAccessLevelId"
                                :state="errors.findIndex(x=>x.key='webUserAccessLevelId')!=-1?webUserModel.webUserAccessLevelId!=null?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col>
                        <label class="custom-input-label">Филиал</label>
                        <b-select
                                :options="orgBranches"
                                value-field="id"
                                text-field="address"
                                rows="6"
                                v-model="webUserModel.orgGeoInfoId"
                                :state="errors.findIndex(x=>x.key='orgGeoInfoId')!=-1?webUserModel.orgGeoInfoId!=null?true:false:null"
                        />
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Логин</label>
                        <b-input
                                :state="stateLogin"
                                v-model="webUserModel.account"
                                required
                                @change="checkLogin"
                                aria-describedby="input-login-feedback input-login-valid"
                        />
                        <!-- This will only be shown if the preceding input has an invalid state -->
                        <b-form-invalid-feedback :state="stateLogin">
                            {{ this.loginMes }}
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="stateLogin">
                            {{ this.loginMes }}
                        </b-form-valid-feedback>
                    </b-col>
                </b-row>
                <b-row no-gutters class="mb-2">
                    <b-col>
                        <label class="custom-input-label">Email</label>
                        <b-input

                                v-model="webUserModel.eMail"
                                required
                                :state="errors.findIndex(x=>x.key='eMail')!=-1?webUserModel.eMail!=null?true:false:null"
                        />
                    </b-col>
                </b-row>

            </b-container>

        </div>

        <template v-slot:modal-footer>
            <div class="w-100">
                <v-row no-gutters  justify="space-between">

                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                color="var(--color-blue)"
                                dark
                                size="sm"
                                @click="onSave"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="close(false)"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import mapper from 'automapper'
    import axios from 'axios'
    import { mapGetters } from 'vuex';
    export default {
        name: "AddNewStaffModal",
        props:["show", "organizationItem"],
        data(){
            return{
                errors:[],
                correctLogin:null,
                webUserModel:{
                    id: null,
                    account: null,
                    userName: null,
                    identityId:null,
                    eMail: null,
                    phoneNumber: null,
                    isAdmin: false,
                    password: null,
                    isActive: true,
                    organizationId: null,
                    orgGeoInfoId:null,
                    organization: null,
                    webUserLogo: null,
                    webUserAccessLevelId:null
                },
                identityModel: {
                    login: null,
                    email: null,
                    phoneNumber: null,
                    password: null,
                    userName: null,
                    isClient: true,
                    isAdministrator: false,
                    organizationId: null,
                    webSite: ''
                },
                loginMes: null

            }
        },
        created(){
            this.$store.dispatch("Partners/getUserAccessLevels").catch(error=>{
                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                    title: `Ошибка получения уровней доступа!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            })

            mapper.createMap("editWebUserModel", "identityModel")
                .forMember('login', function () {
                    this.mapFrom('account')
                })
                .forMember('isAdministrator', function () {
                    return false
                })
                .forMember('isClient', function () {
                    return false
                })
                .forMember('webSite', function () {
                    return null
                })
                .forMember('email', function () {
                    this.mapFrom('eMail')
                })

        },
        computed:{
            stateLogin(){
                if(this.errors.findIndex(x=>x.key='account')!=-1){
                    if( this.webUserModel.account!=null&&this.webUserModel.account!=''){
                        return this.correctLogin;
                    }
                    else return false;
                }
                else if( this.webUserModel.account!=null&&this.webUserModel.account!=''){
                    return this.correctLogin;
                }
                else return null;
            },

            accessLevels(){
                return this.$store.state.Partners.accessLevels
            },

            orgBranches(){
                return this.$store.state.Partners.partnerBranches
            },

            curWebUser(){
                return this.$store.state.userData.webUser
            },

            orgName(){
                if(this.organizationItem)
                    return this.organizationItem.orgName
                else
                    return this.curWebUser.organization
            }
        },
        methods:{
            resetItems(){
                for(let key in this.webUserModel){
                    if(key=='isAdmin')
                        this.webUserModel[key]=false
                    else if(key=='isActive')
                        this.webUserModel[key]=true
                    else if(key=='organizationId')
                            this.webUserModel[key]=this.organizationItem!=null?this.organizationItem.id:this.curWebUser.organizationId
                    else
                        this.webUserModel[key]=null
                }

            },

            formatPhone(value, e){
                //оставляем только цифры
                value= value.replace(/\D/,"")
                value=value.replace(/^[0-8]/,"")
                return value.substr(0,10);
            },

            validateModel() {
                var noError = true;
                this.errors = [];
                if (this.webUserModel.organizationId == null) {
                    this.errors.push({key: "organizationId", mes: "Необходимо выбрать организацию!"});
                    noError = false;
                }
                if (this.webUserModel.userName == null || this.webUserModel.userName == '') {
                    this.errors.push({key: "userName", mes: "Необходимо указать ФИО!"});
                    noError = false;
                }

                if (this.webUserModel.account == null || this.webUserModel.account == '') {
                    this.errors.push({key: "account", mes: "Необходимо указать логин!"});
                    noError = false;
                }

                if (this.webUserModel.phoneNumber == null || this.webUserModel.phoneNumber == '') {
                    this.errors.push({key: "phoneNumber", mes: "Необходимо указать номер телефона!"});
                    noError = false;
                }

                if (this.webUserModel.eMail == null || this.webUserModel.eMail == '') {
                    this.errors.push({key: "eMail", mes: "Необходимо указать Email!"});
                    noError = false;
                }

                return noError;

            },

            generatePass(length) {
                var result = '';
                var characters = '0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },

            async onSave() {
                const vm = this;
                //проверяем на заполнение полей
                if (this.validateModel() == true) {
                    var curUser= this.$store.state.userData.curUser;
                    console.log(this.webUserModel)
                    //1) приводим модель к идентити
                    mapper.map("editWebUserModel", "identityModel", this.webUserModel, this.identityModel)

                    this.identityModel.isAdministrator=false

                        var pass= this.generatePass(6); //рандомный шестизначный пароль
                        this.webUserModel.password=pass;
                        this.identityModel.password=pass;

                        var webUserId = null;
                        //добавляем идентити, получаем ид пользователя
                        await axios.post(`${vm.$root.identityURL}/api/UserAccount/Register`, this.identityModel,{ headers: { Authorization: "Bearer " + curUser.access_token }})
                            .then(response => webUserId = response.data)
                            .catch(error => {
                                this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                    title: `Ошибка!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        //если пользователь добавлен на идентити
                        if (webUserId != null) {
                            this.webUserModel.identityId = webUserId;
                            //загружаем аватар на сервер
                            if (this.userLogoModel != null) {
                                var imgId = null;
                                const imgData = new FormData();
                                imgData.append('files', this.userLogoModel);
                                await axios.post(`${vm.$root.baseUrl}:8085/api/FileUpload`, imgData)
                                    .then(response => imgId = response.data[0])
                                    .catch(error => {
                                        console.log(error)
                                    });
                                if (imgId != null)
                                    this.webUserModel.webUserLogo = imgId;
                            }
                            console.log(this.webUserModel)
                            this.$store.dispatch('Clients/addWebUser', this.webUserModel).then(() => {
                                this.close(true)
                                    this.$bvToast.toast("Пользователь успешно добавлен", {
                                        variant: "success",
                                        toaster: 'b-toaster-bottom-right',
                                        autoHideDelay: 3000,
                                        solid: true
                                    })
                                }
                            ).catch((err) => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        }


                }
                else {
                    this.errors.forEach(err => {
                        this.$bvToast.toast(err.mes, {
                            title: `Не все поля заполнены!`,
                            variant: "warning",
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 7000,
                            solid: true
                        })
                    })
                }
            },

            //проверка на наличие логина
            async checkLogin(value) {
                const vm = this;
                if(value!=null&&value!=''){
                    await axios.get(`${vm.$root.identityURL}/api/useraccount/ChekLogin?login=${value}`)
                        .then(response => {
                            if (response.status == 200) {
                                vm.correctLogin = true;
                                vm.loginMes = response.data;
                            }
                        })
                        .catch(error => {
                            if(error.response.status==400){
                                vm.correctLogin = false;
                                vm.loginMes = error.response.data;
                            }
                        });
                }
            },

            close(isSave){
                this.$emit("close", isSave)
            }
        },
        watch:{

            show(value){
                if(value==true){
                    this.errors=[]
                    this.resetItems()
                    if(this.organizationItem!=null){
                        this.$store.dispatch("Partners/getPartnerBranches", this.organizationItem.id).catch(error=>{
                            this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                title: `Ошибка получения списка филиалов!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        })
                    }
                    else{
                        this.webUserModel.organizationId=this.curWebUser.organizationId;
                        this.$store.dispatch("Partners/getPartnerBranches", this.curWebUser.organizationId).catch(error=>{
                            this.$bvToast.toast(error.response.data != null ? error.response.data : error, {
                                title: `Ошибка получения списка филиалов!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        })
                    }

                }
            }
        }


    }
</script>

<style scoped>
    input.phone + label.phone:before {
        left:9px;
        bottom:7px;

    }

</style>